<script setup>
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { pwaInfo } from 'virtual:pwa-info'

// eslint-disable-next-line no-console
console.log("pwaInfo ", pwaInfo)

//below stuff should maybe be moved into pinia
const updating = ref(false)

const {
  offlineReady,
  needRefresh,
  updateServiceWorker,
} = useRegisterSW({
  immediate: true,
  onRegisteredSW(swUrl, registration) {
    // eslint-disable-next-line no-console
    console.log(`Service Worker at:`, swUrl)
    if (registration) {
      console.log(`SW Registered:`, registration)

      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        console.log("SW onupdatefound", installingWorker.state)

        //if updating (we don't want to block on first registration)
        if(registration.active && installingWorker.state === 'installing'){
          updating.value = true
        }
        installingWorker.onstatechange = () => {
          console.log("SW onstatechange", installingWorker.state)

          if(installingWorker.state === 'activated'){
            updating.value = false
          }
        }
      }

      window.addEventListener("focus", function () {
        console.log(`Checking for updated service worker`)
        registration.update()
      })
      setInterval(async () => {
        // eslint-disable-next-line no-console
        console.log('Checking for sw update')
        await registration.update()
      }, 1000*60*60)
    }
  },
})
</script>

<template>
  <VOverlay
    v-model="updating"
    class="loader-overlay"
    persistent
  >
    <div class="loader-overlay-content text-center">
      <VProgressCircular indeterminate />
      <div class="loader-overlay-content-text">
        Updating app...
      </div>
    </div>
  </VOverlay>
</template>


<style lang="scss" scoped>
.loader-overlay{
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-overlay-content {
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface-card);
  padding: 2.4rem 2rem 2.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1), 0px 29px 52px rgba(0, 0, 0, 0.1);
}

.loader-overlay-content-text {
  color: var(--ds-text-strong);
  margin-top: 1rem;
}
</style>
